import { z } from 'zod'

export const landingSchema = z.object({
  id: z.number(),
  attributes: z.object({
    slug: z.string().min(1),
    title: z.string().min(1),
    publishedAt: z.string().nullable(),
  }),
})

export const schema = z.array(landingSchema)

export type schemaType = z.infer<typeof schema>
